export * from "./Dimensions";

export * from "./util";

export const dimensionsTranslations = {
  cm: "cm",
  in: "in",
  mm: "mm",
  m: "m",

  widthLabel: "Width",
  widthTooSmall: "Min. {{minWidth}}{{units}} width.",
  widthTooBig: "Max. {{maxWidth}}{{units}} width.",
  widthHelperText: "Min {{minWidth}}{{units}}, max {{maxWidth}}{{units}}",
  heightLabel: "Height",
  heightTooSmall: "Min. {{minHeight}}{{units}} height.",
  heightTooBig: "Max. {{maxHeight}}{{units}} height.",
  heightHelperText: "Min {{minHeight}}{{units}}, max {{maxHeight}}{{units}}",
};
